import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'aims-help',
  template: `
  `,
  styleUrls: ['./aims-help.component.css']
})
export class AimsHelpComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  @Input() public docPath: string = null;
  @Input() public cshid: string = null;

  navigate() {
      if (isPlatformBrowser(this.platformId)){
        const finalUrl: string = (this.docPath) ? `${environment.assetsPath}/Documentation/Output/HTML5/${this.docPath}` :
           `${environment.assetsPath}/Documentation/Output/HTML5/Output/HTML5/Default.htm#cshid=${this.cshid}&skinName=TopNav`;
        window.open(finalUrl,"_blank");
      }
  }

  ngOnInit(): void {
  }

}
